import React from 'react';
import { Link } from 'react-router-dom';

const Footer = () => {
  return (
    <footer className="footer-area">
      <div className="footer-widget">
        <div className="container">
          <div className="row footer-widget-wrapper pt-120 pb-70">
            <div className="col-md-6 col-lg-3">
              <div className="footer-widget-box about-us">
                <a href="#" className="footer-logo">
                  <img src="/images/logo1.jpg" alt="Logo" />
                </a>
               
                <ul className="footer-contact">
  <li>
    <a href="tel:+918767459909">
      <i className="fas fa-phone"></i> +91 8767459909
    </a>
  </li>
  <li>
    <a href="tel:+919766866789">
      <i className="fas fa-phone"></i> +91 9766866789
    </a>
  </li>
  
  <li>
    <a href="mailto:booking@vedanttravels.in">
      <i className="fas fa-envelope"></i> booking@vedanttravels.in
    </a>
  </li>

  <li className='' >
    <i className="fas fa-map-marker-alt "></i>  Vedant Travels<br/>
   S/R No. 66/1. Dhore Patil Farm ,<br/>Near New Bharat Bakery ,
    <br/>New Sangvi Pimpri-Chinchwad,<br/> Pune Maharashtra India- 411027.
  </li>
  <li>
  <div className="contact-map">





  <iframe src="https://www.google.com/maps/embed?pb=!1m17!1m12!1m3!1d264.1947651201676!2d73.80941494290873!3d18.581811636502145!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m2!1m1!2zMTjCsDM0JzU0LjYiTiA3M8KwNDgnMzQuMiJF!5e1!3m2!1sen!2sin!4v1741180017614!5m2!1sen!2sin" width="600" height="450" allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>
</div>
  </li>
</ul>

              </div>
            </div>
            <div className="col-md-6 col-lg-3">
              <div className="footer-widget-box list">
                <h4 className="footer-widget-title">Services We Provides </h4>
                <div className="footer-list">
                
                  <Link className="mx-md-2" to="/Pune-to-Mumbai-Cab"><i className=" fa fa-car darkcolor"></i> Pune to Mumbai Cab</Link>
<Link className="mx-md-2" to="/Pune-to-Mumbai-Airport-Cab"><i className=" fa fa-car darkcolor"></i> Pune to Mumbai Airport Cab</Link>
<Link className="mx-md-2" to="/Pune-to-Mumbai-International-Airport-Cab"><i className=" fa fa-car darkcolor"></i> Pune to Mumbai International Airport Cab</Link>
<Link className="mx-md-2" to="/Pune-to-Mumbai-One-Way-Cab"><i className=" fa fa-car darkcolor"></i> Pune to Mumbai One Way Cab</Link>
<Link className="mx-md-2" to="/Pune-Mumbai-Car-Hire"><i className=" fa fa-car darkcolor"></i> Pune Mumbai Car Hire</Link>
<Link className="mx-md-2" to="/Pune-to-Mumbai-Taxi-Fare"><i className=" fa fa-car darkcolor"></i> Pune to Mumbai Taxi Fare</Link>
<Link className="mx-md-2" to="/Pune-to-Mumbai-Online-Cab-Booking"><i className=" fa fa-car darkcolor"></i> Pune to Mumbai Online Cab Booking</Link>
<Link className="mx-md-2" to="/Pimpri-Chinchwad-to-Mumbai-Cab"><i className=" fa fa-car darkcolor"></i> Pimpri Chinchwad to Mumbai Cab</Link>
<Link className="mx-md-2" to="/Baner-to-Mumbai-Cabs"><i className=" fa fa-car darkcolor"></i> Baner to Mumbai Cabs</Link>
<Link className="mx-md-2" to="/Hinjewadi-to-Mumbai-Cab"><i className=" fa fa-car darkcolor"></i> Hinjewadi to Mumbai Cab</Link>
<Link className="mx-md-2" to="/Pimple-Saudagar-to-Mumbai-Cab-Service"><i className=" fa fa-car darkcolor"></i> Pimple Saudagar to Mumbai Cab Service</Link>
<Link className="mx-md-2" to="/Wakad-to-Mumbai-Cab"><i className=" fa fa-car darkcolor"></i> Wakad to Mumbai Cab</Link>
<Link className="mx-md-2" to="/Hadapsar-to-Mumbai-Cab"><i className=" fa fa-car darkcolor"></i> Hadapsar to Mumbai Cab</Link>
<Link className="mx-md-2" to="/Kalyani-Nagar-to-Mumbai-Taxi"><i className=" fa fa-car darkcolor"></i> Kalyani Nagar to Mumbai Taxi</Link>
<Link className="mx-md-2" to="/Koregaon-Park-to-Mumbai-Cab"><i className=" fa fa-car darkcolor"></i> Koregaon Park to Mumbai Cab</Link>
<Link className="mx-md-2" to="/Kothrud-to-Mumbai-Cab"><i className=" fa fa-car darkcolor"></i> Kothrud to Mumbai Cab</Link>
<Link className="mx-md-2" to="/Kharadi-to-Mumbai-Cab"><i className=" fa fa-car darkcolor"></i> Kharadi to Mumbai Cab</Link>
<Link className="mx-md-2" to="/Shivajinagar-to-Mumbai-Cab"><i className=" fa fa-car darkcolor"></i> Shivajinagar to Mumbai Cab</Link>
<Link className="mx-md-2" to="/Pune-to-Mumbai-Ertiga-Cab"><i className=" fa fa-car darkcolor"></i> Pune to Mumbai Ertiga Cab</Link>
<Link className="mx-md-2" to="/Pune-to-Mumbai-Innova-Crysta-Cab"><i className=" fa fa-car darkcolor"></i> Pune to Mumbai Innova Crysta Cab</Link>

<Link className="mx-md-2" to="/Kondhwa-to-Mumbai-Cab"><i className="fa fa-car darkcolor"></i> Kondhwa to Mumbai Cab</Link>
<Link className="mx-md-2" to="/Viman-Nagar-to-Mumbai-Cabs"><i className="fa fa-car darkcolor"></i> Viman Nagar to Mumbai Cabs</Link>
<Link className="mx-md-2" to="/Katraj-to-Mumbai-Cab-Service"><i className="fa fa-car darkcolor"></i> Katraj to Mumbai Cab Service</Link>
<Link className="mx-md-2" to="/Pune-Station-to-Mumbai-Cabs-Service"><i className="fa fa-car darkcolor"></i> Pune Station to Mumbai Cabs Service</Link>  
<Link className="mx-md-2" to="/Boat-Club-Road-to-Mumbai-Cab"><i className="fa fa-car darkcolor"></i> Boat Club Road to Mumbai Cab</Link>
<Link className="mx-md-2" to="/Vishrantwadi-to-Mumbai-Cab"><i className="fa fa-car darkcolor"></i> Vishrantwadi to Mumbai Cab</Link>
<Link className="mx-md-2" to="/Alandi-to-Mumbai-Cabs-Service"><i className="fa fa-car darkcolor"></i> Alandi to Mumbai Cabs Service</Link>
<Link className="mx-md-2" to="/Wagholi-to-Mumbai-Cab"><i className="fa fa-car darkcolor"></i> Wagholi to Mumbai Cab</Link>
<Link className="mx-md-2" to="/Mumbai-Airport-to-Pune-Cab"><i className="fa fa-car darkcolor"></i> Mumbai Airport to Pune Cab</Link>
<Link className="mx-md-2" to="/Dadar-to-Pune-Cab"><i className="fa fa-car darkcolor"></i> Dadar to Pune Cab</Link>
<Link className="mx-md-2" to="/Mumbai-to-Pune-One-Way-Cab"><i className="fa fa-car darkcolor"></i> Mumbai to Pune One Way Cab</Link>
                </div>
              </div>
            </div>
            <div className="col-md-6 col-lg-3">
              <div className="footer-widget-box list">
                <h4 className="footer-widget-title">Services We Provides </h4>
                <div className="footer-list">
                 


                  
             


<Link className="mx-md-2 " to="/Andheri-to-Pune-Cab"><i className="fa fa-car darkcolor"></i> Andheri to Pune Cab</Link>

<Link className="mx-md-2 " to="/Bandra-to-Pune-Cab"><i className="fa fa-car darkcolor"></i> Bandra to Pune Cab</Link>
<Link className="mx-md-2" to="/Santacruz-to-Pune-Cab"><i className="fa fa-car darkcolor"></i> Santacruz to Pune Cab</Link>
<Link className="mx-md-2" to="/Mumbai-Central-to-Pune-Cab"><i className="fa fa-car darkcolor"></i> Mumbai Central to Pune Cab</Link>
<Link className="mx-md-2" to="/Borivali-to-Pune-Cab"><i className="fa fa-car darkcolor"></i> Borivali to Pune Cab</Link>
<Link className="mx-md-2" to="/Mumbai-to-Pimpri-Chinchwad-Cab"><i className="fa fa-car darkcolor"></i> Mumbai to Pimpri Chinchwad Cab</Link>
<Link className="mx-md-2" to="/Navi-Mumbai-to-Pune-Cab"><i className="fa fa-car darkcolor"></i> Navi Mumbai to Pune Cab</Link>
<Link className="mx-md-2" to="/Mumbai-Airport-to-Pune-City-Cab"><i className="fa fa-car darkcolor"></i> Mumbai Airport to Pune City Cab</Link>
<Link className="mx-md-2" to="/Mumbai-to-Pune-Daily-Cab"><i className="fa fa-car darkcolor"></i> Mumbai to Pune Daily Cab</Link>

<Link className="mx-md-2" to="/Mumbai-Pune-Cab-Booking"><i className="fa fa-car darkcolor"></i> Mumbai Pune Cab Booking</Link>
<Link className="mx-md-2" to="/Jogeshwari-to-Pune-Cab-Service"><i className="fa fa-car darkcolor"></i> Jogeshwari to Pune Cab Service</Link>
<Link className="mx-md-2" to="/Goregaon-to-Pune-Cab"><i className="fa fa-car darkcolor"></i> Goregaon to Pune Cab</Link>
<Link className="mx-md-2" to="/Kandivali-to-Pune-Cab"><i className="fa fa-car darkcolor"></i> Kandivali to Pune Cab</Link>
<Link className="mx-md-2" to="/Vile-Parle-to-Pune-Cab-Service"><i className="fa fa-car darkcolor"></i> Vile Parle to Pune Cab Service</Link>
<Link className="mx-md-2" to="/Bhandup-to-Pune-Cab"><i className="fa fa-car darkcolor"></i> Bhandup to Pune Cab</Link>
<Link className="mx-md-2" to="/Ghatkopar-to-Pune-Cab-Service"><i className="fa fa-car darkcolor"></i> Ghatkopar to Pune Cab Service</Link>
<Link className="mx-md-2" to="/Kurla-to-Pune-Taxi-Service"><i className="fa fa-car darkcolor"></i> Kurla to Pune Taxi Service</Link>
<Link className="mx-md-2" to="/Powai-Mumbai-Pune-Cab-Service"><i className="fa fa-car darkcolor"></i> Powai Mumbai Pune Cab Service</Link>
<Link className="mx-md-2" to="/Chembur-to-Pune-Cab"><i className="fa fa-car darkcolor"></i> Chembur to Pune Cab</Link>
<Link className="mx-md-2" to="/Terminal-1-2-3-Mumbai-Airport-to-Pune-Cab"><i className="fa fa-car darkcolor"></i> Terminal 1,2,3 Mumbai Airport to Pune Cab</Link>
<Link className="mx-md-2" to="/Thane-to-Pune-Cab"><i className="fa fa-car darkcolor"></i> Thane to Pune Cab</Link>
<Link className="mx-md-2" to="/Vikhroli-to-Pune-Cab-Services"><i className="fa fa-car darkcolor"></i> Vikhroli to Pune Cab Services</Link>
<Link className="mx-md-2" to="/Mumbai-to-Pune-Innova-Crysta-Cab"><i className="fa fa-car darkcolor"></i> Mumbai to Pune Innova Crysta Cab</Link>
<Link className="mx-md-2" to="/Mumbai-Airport-to-Pune-Ertiga-on-Rent"><i className="fa fa-car darkcolor"></i> Mumbai Airport to Pune Ertiga on Rent</Link>
<Link className="mx-md-2" to="/Mumbai-Airport-Car-Rental"><i className="fa fa-car darkcolor"></i> Mumbai Airport Car Rental</Link>
<Link className="mx-md-2" to="/Panvel-to-Pune-Cab"><i className="fa fa-car darkcolor"></i> Panvel to Pune Cab</Link>
<Link className="mx-md-2" to="/Church-Gate-to-Pune-Cab-Service"><i className="fa fa-car darkcolor"></i> Church Gate to Pune Cab Service</Link>
<Link className="mx-md-2" to="/Byculla-to-Pune-Cab-Service"><i className="fa fa-car darkcolor"></i> Byculla to Pune Cab Service</Link>
<Link className="mx-md-2" to="/Vashi-to-Pune-Cab"><i className="fa fa-car darkcolor"></i> Vashi to Pune Cab</Link>
<Link className="mx-md-2" to="/Kharghar-to-Pune-Cab"><i className="fa fa-car darkcolor"></i> Kharghar to Pune Cab</Link>

                </div>
              </div>
            </div>
            <div className="col-md-6 col-lg-3">
              <div className="footer-widget-box list">
                <h4 className="footer-widget-title">Services We Provides</h4>
                <div className="footer-newsletter footer-list">


              





<Link className="mx-md-2" to="/Mankhurd-to-Pune-Cab"><i className="fa fa-car darkcolor"></i> Mankhurd to Pune Cab</Link>
<Link className="mx-md-2" to="/One-Way-Taxi-Mumbai-to-Pune"><i className="fa fa-car darkcolor"></i> One Way Taxi Mumbai to Pune</Link>
<Link className="mx-md-2" to="/Innova-Crysta-on-Rent-in-Pune"><i className="fa fa-car darkcolor"></i> Innova Crysta on Rent in Pune</Link>
<Link className="mx-md-2" to="/Ertiga-Cab-Booking-in-Pune"><i className="fa fa-car darkcolor"></i> Ertiga Cab Booking in Pune</Link>
<Link className="mx-md-2" to="/Kia-Carens-On-Rent-in-Pune"><i className="fa fa-car darkcolor"></i> Kia Carens On Rent in Pune</Link>
<Link className="mx-md-2" to="/Swift-Dzire-On-Rent-in-Pune"><i className="fa fa-car darkcolor"></i> Swift Dzire On Rent in Pune</Link>
<Link className="mx-md-2" to="/Sedan-Cabs-Booking-in-Pune"><i className="fa fa-car darkcolor"></i> Sedan Cabs Booking in Pune</Link>
<Link className="mx-md-2" to="/Force-Urbania-On-Rent-in-Pune"><i className="fa fa-car darkcolor"></i> Force Urbania On Rent in Pune</Link>
<Link className="mx-md-2" to="/Fortuner-On-Rent-in-Pune"><i className="fa fa-car darkcolor"></i> Fortuner On Rent in Pune</Link>


<Link className="mx-md-2" to="/Mumbai-to-Ashtavinayak-Cab-Service"><i className="fa fa-car darkcolor"></i> Mumbai to Ashtavinayak Cab Service</Link>
<Link className="mx-md-2" to="/Mumbai-Cab-Service"><i className="fa fa-car darkcolor"></i> Mumbai Cab Service</Link>
<Link className="mx-md-2" to="/Mumbai-to-Shirdi-Cab"><i className="fa fa-car darkcolor"></i> Mumbai to Shirdi Cab</Link>
<Link className="mx-md-2" to="/Mumbai-to-Akkalkot-Cab-Fare"><i className="fa fa-car darkcolor"></i> Mumbai to Akkalkot Cab Fare</Link>
<Link className="mx-md-2" to="/Mumbai-Outstation-Cabs"><i className="fa fa-car darkcolor"></i> Mumbai Outstation Cabs</Link>
<Link className="mx-md-2" to="/Mumbai-to-5-Jyotirlinga-Darshan-Cab"><i className="fa fa-car darkcolor"></i> Mumbai to 5 Jyotirlinga Darshan Cab</Link>
<Link className="mx-md-2" to="/Mumbai-to-Mahabaleshwar-Cab"><i className="fa fa-car darkcolor"></i> Mumbai to Mahabaleshwar Cab</Link>
<Link className="mx-md-2" to="/Mumbai-to-Konkan-Darshan-Cab-Booking"><i className="fa fa-car darkcolor"></i> Mumbai to Konkan Darshan Cab Booking</Link>
<Link className="mx-md-2" to="/Mumbai-to-Kolhapur-Cabs"><i className="fa fa-car darkcolor"></i> Mumbai to Kolhapur Cabs</Link>
<Link className="mx-md-2" to="/Mumbai-to-Bhimashankar-Cab"><i className="fa fa-car darkcolor"></i> Mumbai to Bhimashankar Cab</Link>
<Link className="mx-md-2" to="/Mumbai-to-Pandharpur-Cab"><i className="fa fa-car darkcolor"></i> Mumbai to Pandharpur Cab</Link>
<Link className="mx-md-2" to="/Mumbai-to-Goa-Cabs"><i className="fa fa-car darkcolor"></i> Mumbai to Goa Cabs</Link>
<Link className="mx-md-2" to="/Mumbai-Airport-Taxi-Booking-Online"><i className="fa fa-car darkcolor"></i> Mumbai Airport Taxi Booking Online</Link>
<Link className="mx-md-2" to="/Online-Taxi-Booking-Mumbai"><i className="fa fa-car darkcolor"></i> Online Taxi Booking Mumbai</Link>
<Link className="mx-md-2" to="/Cab-Service-in-Navi-Mumbai"><i className="fa fa-car darkcolor"></i> Cab Service in Navi Mumbai</Link>
<Link className="mx-md-2" to="/Mumbai-to-Kashi-Cab-Service"><i className="fa fa-car darkcolor"></i> Mumbai to Kashi Cab Service</Link>
<Link className="mx-md-2" to="/Best-Wedding-Car-Rental-in-Mumbai"><i className="fa fa-car darkcolor"></i> Best Wedding Car Rental in Mumbai</Link>
<Link className="mx-md-2" to="/Mumbai-to-Aurangabad-Cab"><i className="fa fa-car darkcolor"></i> Mumbai to Aurangabad Cab</Link>
<Link className="mx-md-2" to="/Mumbai-to-Hyderabad-Cab"><i className="fa fa-car darkcolor"></i> Mumbai to Hyderabad Cab</Link>
<Link className="mx-md-2" to="/Mumbai-to-Bangalore-Cab"><i className="fa fa-car darkcolor"></i> Mumbai to Bangalore Cab</Link>
<Link className="mx-md-2" to="/Cab-Service-in-Thane"><i className="fa fa-car darkcolor"></i> Cab Service in Thane</Link>
<Link className="mx-md-2" to="/Mumbai-to-Varanasi-Cabs"><i className="fa fa-car darkcolor"></i> Mumbai to Varanasi Cabs</Link>


                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="copyright">
        <div className="container">
          <div className="row">
            <div className="col-md-6 align-self-center">
              <p className="copyright-text">
              All Rights Reserved &copy;  <span className="darkcolorrr">Vedant  Travels</span> <span id="date">{new Date().getFullYear()}</span>{' '}
                <span href="#"> Developed By </span> <a href="https://www.dexterintelligence.com/" className='d-inline' target="_blank" rel="noopener noreferrer">
                <span className="darkcolorrr">&nbsp;Dexter Intelligence</span>
              </a> | Hosted By <a href="https://www.urvahosting.com/" className='d-inline ' target="_blank" rel="noopener noreferrer">
                <span className="darkcolorrr">&nbsp;Urva Hosting</span>
              </a>
              </p>
            </div>
            <div className="col-md-6 align-self-center">
              <ul className="footer-social">
                <li>
                  <a href="#">
                    <i className="fab fa-facebook-f"></i>
                  </a>
                </li>
                <li>
                  <a href="#">
                    <i className="fab fa-twitter"></i>
                  </a>
                </li>
                <li>
                  <a href="#">
                    <i className="fab fa-linkedin-in"></i>
                  </a>
                </li>
                <li>
                  <a href="#">
                    <i className="fab fa-youtube"></i>
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
